import React, { Component } from "react";
import Header from "../../layout/Header";
import BannerSimple from "../../layout/BannerSimple";
import Footer from "../../layout/Footer";
import SEO from "../../layout/SEO";
import ArticlesGrid from "../../layout/ArticlesGrid";
import publicApi from "../../../utils/publicApi";
import { isPublicArticle } from "../../../utils/articleVisibility";

export default class Veille extends Component {
	constructor(props) {
		super(props);
		this.state = {
			articlesTechnologique: [],
			articlesJuridique: [],
			loading: true
		};
	}

	componentDidMount() {
		window.resetScript();
		this.loadArticles();
	}

	loadArticles = async () => {
		try {
			this.setState({ loading: true });

			// Charger les articles technologiques
			const responseTech = await publicApi.get("/api/articles?type=VEILLE_TECHNOLOGIQUE&limit=100");
			const articlesTech = (responseTech.data.articles || []).filter(isPublicArticle);

			// Charger les articles juridiques
			const responseJur = await publicApi.get("/api/articles?type=VEILLE_JURIDIQUE&limit=100");
			const articlesJur = (responseJur.data.articles || []).filter(isPublicArticle);

			this.setState({
				articlesTechnologique: articlesTech,
				articlesJuridique: articlesJur,
				loading: false
			});
		} catch (error) {
			console.error("Error loading articles:", error);
			this.setState({ loading: false });
		}
	};

	render() {
		const { articlesTechnologique, articlesJuridique, loading } = this.state;
		const hasTechnologique = articlesTechnologique.length > 0;
		const hasJuridique = articlesJuridique.length > 0;

		return (
			<>
				<SEO
					title="Veille"
					description="Découvrez mes articles de veille technologique et juridique pour rester à jour sur les dernières tendances et évolutions."
					keywords="veille, veille technologique, veille juridique, articles, tendances"
				/>
				<Header active={ "Veille" } modeDark={ true } />

				<BannerSimple title = "Veille" boxElement = { [ { name: "Accueil", link: "/" }, { name: "Veille", link: "/veille" } ] } />

				<section className="portfolio_details_area section-gap">
					<div className="container">
						{loading ? (
							<div className="text-center py-5">
								<p>Chargement des articles...</p>
							</div>
						) : (
							<>
								{hasTechnologique && (
									<div className="veille-section" style={{ marginBottom: "4rem" }}>
										<div className="section-title" style={{ marginBottom: "2rem" }}>
											<h2 style={{ 
												fontSize: "2rem", 
												fontWeight: "700", 
												color: "#2c3e50",
												borderBottom: "3px solid #667eea",
												paddingBottom: "1rem",
												marginBottom: "2rem"
											}}>
												<i className="lnr lnr-laptop-phone" style={{ marginRight: "0.5rem" }}></i>
												Veille Technologique
											</h2>
											<p style={{ color: "#6c757d", fontSize: "1.1rem" }}>
												Cette section présente mon travail de veille technologique.
											</p>
										</div>
										<ArticlesGrid 
											type="VEILLE_TECHNOLOGIQUE"
											itemsPerPage={12}
											emptyMessage="Aucun article de veille technologique trouvé"
										/>
									</div>
								)}

								{hasTechnologique && hasJuridique && (
									<hr style={{ 
										margin: "4rem 0", 
										border: "none", 
										borderTop: "2px solid #dee2e6" 
									}} />
								)}

								{hasJuridique && (
									<div className="veille-section">
										<div className="section-title" style={{ marginBottom: "2rem" }}>
											<h2 style={{ 
												fontSize: "2rem", 
												fontWeight: "700", 
												color: "#2c3e50",
												borderBottom: "3px solid #667eea",
												paddingBottom: "1rem",
												marginBottom: "2rem"
											}}>
												<i className="lnr lnr-chart-bars" style={{ marginRight: "0.5rem" }}></i>
												Veille Juridique
											</h2>
											<p style={{ color: "#6c757d", fontSize: "1.1rem" }}>
												Cette section présente mon travail de veille juridique.
											</p>
										</div>
										<ArticlesGrid 
											type="VEILLE_JURIDIQUE"
											itemsPerPage={12}
											emptyMessage="Aucun article de veille juridique trouvé"
										/>
									</div>
								)}

								{!hasTechnologique && !hasJuridique && (
									<div className="text-center py-5">
										<p>Aucun article de veille trouvé</p>
									</div>
								)}
							</>
						)}
					</div>
				</section>

				<Footer />
			</>
		);
	}
}
